<template>
  <div class="modal fade show d-block" style="background: rgba(0, 0, 0, 0.5)">
    <div class="modal-dialog modal-xl modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Factura FEL</h5>
          <button class="btn-close" @click="$emit('cerrar')"></button>
        </div>
        <div class="modal-body">
          <div class="btn-group mb-3" role="group">
            <button
              type="button"
              class="btn btn-sm"
              :class="formatoActivo === 'carta' ? 'btn-primary' : 'btn-outline-secondary'"
              @click="cambiarFormato('carta')"
            >
              Carta
            </button>
            <button
              type="button"
              class="btn btn-sm"
              :class="formatoActivo === 'ticket' ? 'btn-primary' : 'btn-outline-secondary'"
              @click="cambiarFormato('ticket')"
            >
              Ticket
            </button>
            <button
              type="button"
              class="btn btn-sm"
              :class="formatoActivo === 'pdf' ? 'btn-primary' : 'btn-outline-secondary'"
              @click="cambiarFormato('pdf')"
            >
              Certificador
            </button>
          </div>

          <div v-if="cargando" class="text-center py-5">
            <div class="spinner-border text-primary"></div>
            <div class="text-muted mt-2">Cargando factura...</div>
          </div>

          <div v-else-if="error" class="alert alert-danger">{{ error }}</div>

          <iframe
            v-else-if="blobUrl"
            ref="visor"
            :src="blobUrl"
            style="width: 100%; height: 70vh; border: 0"
          ></iframe>
        </div>
        <div class="modal-footer">
          <button class="btn btn-secondary" @click="$emit('cerrar')">Cerrar</button>
          <button class="btn btn-outline-primary" @click="descargar" :disabled="!blobUrl">
            <i class="bi bi-download me-1"></i>Descargar PDF
          </button>
          <button class="btn btn-primary" @click="imprimir" :disabled="!blobUrl">
            <i class="bi bi-printer me-1"></i>Imprimir
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  name: 'FelPreviewModal',
  props: {
    uuid: { type: String, required: true },
    formato: { type: String, default: 'carta' },
  },
  emits: ['cerrar'],
  data() {
    return {
      blobUrl: null,
      cargando: false,
      error: null,
      formatoActivo: this.formato,
    };
  },
  mounted() {
    this.cargar();
  },
  beforeUnmount() {
    if (this.blobUrl) {
      URL.revokeObjectURL(this.blobUrl);
    }
  },
  methods: {
    cambiarFormato(formato) {
      if (formato === this.formatoActivo) return;
      this.formatoActivo = formato;
      this.cargar();
    },
    async cargar() {
      this.cargando = true;
      this.error = null;
      if (this.blobUrl) {
        URL.revokeObjectURL(this.blobUrl);
        this.blobUrl = null;
      }
      try {
        const res = await axios.get(`facturas-fel/${this.uuid}/${this.formatoActivo}`, {
          responseType: 'blob',
        });

        if (!res.data.type || !res.data.type.includes('pdf')) {
          const texto = await res.data.text();
          try {
            const json = JSON.parse(texto);
            this.error = json.message || 'No se pudo cargar la factura.';
          } catch {
            this.error = 'No se pudo cargar la factura.';
          }
          return;
        }

        this.blobUrl = URL.createObjectURL(new Blob([res.data], { type: 'application/pdf' }));
      } catch (e) {
        this.error = await this.extraerMensajeError(e);
      } finally {
        this.cargando = false;
      }
    },
    async extraerMensajeError(e) {
      const data = e.response?.data;
      if (data instanceof Blob) {
        try {
          const json = JSON.parse(await data.text());
          return json.message || 'Error al obtener la factura.';
        } catch {
          return 'Error al obtener la factura.';
        }
      }
      return data?.message || 'Error al obtener la factura.';
    },
    descargar() {
      if (!this.blobUrl) return;
      const a = document.createElement('a');
      a.href = this.blobUrl;
      a.download = `factura-${this.uuid}-${this.formatoActivo}.pdf`;
      a.click();
    },
    imprimir() {
      if (!this.$refs.visor) return;
      try {
        this.$refs.visor.contentWindow.print();
      } catch {
        window.open(this.blobUrl, '_blank');
      }
    },
  },
};
</script>
